module.exports = __webpack_public_path__ + "static/assets/0f348ce4a43ed4d265671d2b16be910a.svg";